<template>
  <div>
    <SmartTitle
      weight="medium"
      heading="1"
    >Criar Novo Ponto de Venda</SmartTitle>
    <SmartCard>
      <div class="p-3">
        <SmartTitle
          weight="regular"
          heading="2"
          class="mb-2"
        >Informações de PDV</SmartTitle>
        <SmartRow class="flex sub-form justify-between flex-nowrap flex-row">
          <div class="w-full pl-1">
            <SmartInput
              label="Nome Fantasia *"
              id="companyName"
              name="companyName"
              placeholder="TradeUp Group"
              v-model="companyName"
              v-validate="'required'"
              :error="errors.first('companyName')"
            />
            <SmartInput
              label="Telefone *"
              id="phone"
              class="pb-1-2"
              :mask="['(##) ####-####', '(##) #####-####']"
              placeholder="(11) 98765-4321"
              v-model="phone"
              name="phone"
              v-validate="'required|celPhone'"
              :error="errors.first('phone')"
            />
            <VSelect
              placeholder="Segmento"
              :items="getPlaceSegments"
              class="pb-1-2"
              label="Segmento *"
              item-text="name"
              item-value="id"
              v-model="segmentSelected"
              name="segmento"
              v-validate="'required'"
              :error="errors.first('segmento')"
            >
              <template v-slot:item="{ item, index }">
                <div class="v-list__tile__content">
                  <div :id="`segments-${index}`" class="v-list__tile__title">{{ item.name }}</div>
                </div>
              </template>
            </VSelect>
            <VSelect
              label="Regional *"
              placeholder="TCN"
              :items="views"
              item-text="name"
              item-value="id"
              name="selectedViews"
              v-model="selectedViews"
              v-validate="'required'"
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index === 0">
                  <span :id="`view-${index}`">{{ item.name }}</span>
                </v-chip>
                <span
                  :id="`view-outros`"
                  v-if="index === 1"
                  class="grey--text caption"
                >+ (Outros)</span>
              </template>
            </VSelect>
            <VSelect
              placeholder="Selecione o canal"
              :items="channels"
              label="Canal *"
              item-text="name"
              item-value="id"
              v-model="selectedChannels"
              name="channels"
              :error="errors.first('channels')"
              v-validate="'required'">
              <template v-slot:item="{ item, index }">
                <div class="v-list__tile__content">
                  <div :id="`channel-${channels.indexOf(item)}`" class="v-list__tile__title">{{ item.name }}</div>
                </div>
              </template>
            </VSelect>
            <SmartInput
              label="Nome Vendedor *"
              id="salesmanName"
              name="salesmanName"
              placeholder="Vendedor Nome"
              v-model="salesmanName"
              v-validate="'required'"
              :error="errors.first('salesmanName')"
            />
            <SmartInput
              label="CPF Vendedor *"
              id="salesmanCpf"
              name="salesmanCpf"
              v-model="salesmanCpf"
              :mask="['###.###.###-##']"
              v-validate="'required|cpf'"
              placeholder="548.416.877-50"
              :error="errors.first('salesmanCpf')"
            />
            <div class="mb-4">
              <smartP class="p-none mb-1">Status</smartP>
              <div class="flex align-center ml-2 relative status-box">
                <p v-if="status">Ativo</p>
                <p v-else>Inativo</p>
                <v-switch
                  color="default"
                  :value="status"
                  v-model="status"
                  @change="alterStatusSwitchOfNullToFalse(status)"
                  class="ml-4 absolute switch-right p-0 m-0"
                />
              </div>
            </div>
          </div>

          <div class="w-full pl-3">
            <SmartInput
              label="CPF / CNPJ *"
              id="cpfCnpj"
              :mask="['##.###.###/####-##', '###.###.###-##']"
              placeholder="94.224.991/0001-30"
              v-model="cpfCnpj"
              name="cpfCnpj"
              v-validate="changeValidateCpfCnpj"
              :error="errors.first('cpfCnpj')"
            />
            <SmartInput
              label="Razão Social *"
              id="social"
              placeholder="Razão Social"
              name="social"
              v-model="placeName"
              v-validate="'required'"
            />
            <SmartInput
              label="Curva Chip *"
              id="simcard_curve"
              placeholder="A"
              :mask="'A'"
              name="simcard_curve"
              v-validate="'required|curve'"
              v-model="simcard_curve"
              :error="errors.first('simcard_curve')"
            />
            <SmartInput
              label="Curva de Recarga *"
              id="top_up_curve"
              placeholder="C"
              name="top_up_curve"
              :mask="'A'"
              v-validate="'required|curve'"
              v-model="top_up_curve"
              :error="errors.first('top_up_curve')"
            />
            <VSelect
              placeholder="Distribuidores"
              :items="distributors"
              label="Distribuidores *"
              item-text="name"
              item-value="id"
              v-model="selectedDistributors"
              name="distributors"
              :error="errors.first('distributors')"
              v-validate="'required'"
            >
              <template v-slot:item="{ item, index }">
                <div class="v-list__tile__content">
                  <div :id="`distributor-${distributors.indexOf(item)}`" class="v-list__tile__title">{{ item.name }}</div>
                </div>
              </template>
            </VSelect>
            <VSelect
              placeholder="Filial"
              :items="branch"
              label="Filial *"
              v-model="selectBranch"
              name="branch"
              @change="alterValueBranch(selectBranch)"
              :error="errors.first('branch')"
              v-validate="'required'"
            >
              <template v-slot:item="{ item, index }">
                <div class="v-list__tile__content">
                  <div :id="`branch-${branch.indexOf(item)}`" class="v-list__tile__title">{{ item }}</div>
                </div>
              </template>
            </VSelect>
            <VSelect
              placeholder="DDD"
              :items="listDDD"
              label="DDD *"
              item-text="ddd"
              item-value="id"
              v-model="submitDDDS"
              name="ddd"
              v-validate="'required'"
              class="pb-1-4 mb-2"
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index === 0">
                  <span :id="`ddd-${listDDD.indexOf(item)}`">{{ item.ddd }}</span>
                </v-chip>
                <span
                  v-if="index === 1"
                  class="grey--text caption"
                >+ (Outros)</span>
              </template>
            </VSelect>
          </div>
        </SmartRow>

        <SmartTitle
          weight="regular"
          heading="2"
          class="mb-2"
        >Informações de Endereço do PDV</SmartTitle>
        <SmartRow class="flex justify-between flex-row flex-nowrap sub-form">
          <div class="w-full pl-1">
            <SmartInput
              label="CEP *"
              id="zipCode"
              :mask="'#####-###'"
              v-model="zipCode"
              name="zipCode"
              placeholder="06454-000"
              v-validate="'required'"
              @change="reloadAddress"
              :error="errors.first('zipCode')"
              class="pb-1-2"
            />
            <VAutocomplete
              :items="cities"
              label="Cidade *"
              item-text="name"
              item-value="city_id"
              v-model="city"
              name="city"
              placeholder="Campos do Jordão"
              v-validate="'required'"
              :error="!!errors.first('city')"
            >
              <template v-slot:item="{ item, index }">
                <div class="v-list__tile__content">
                  <div :id="`city-${cities.indexOf(item)}`" class="v-list__tile__title">{{ item.name }}</div>
                </div>
              </template>
            </VAutocomplete>

            <SmartInput
              label="Bairro *"
              id="neighborhood"
              v-model="neighborhood"
              name="neighborhood"
              placeholder="Carandá Bosque"
              v-validate="'required'"
              :error="errors.first('neighborhood')"
            />

            <SmartInput
              label="Complemento *"
              id="complement"
              placeholder="Apto 123"
              v-model="complement"
              name="complement"
              v-validate="'required'"
              :error="errors.first('complement')"
            />

            <SmartInput
              label="Latitude *"
              id="latitude"
              name="latitude"
              placeholder="0000000000000"
              v-validate="'required'"
              v-model="latitude"
              disabled
            />
          </div>

          <div class="w-full pl-3">
            <VSelect
              :items="states"
              label="UF *"
              item-text="name"
              item-value="uf"
              v-model="state"
              @change="reloadCities"
              name="state"
              placeholder="São Paulo"
              v-validate="'required'"
              :error="errors.first('state')"
            >
              <template v-slot:item="{ item }">
                <div class="v-list__tile__content">
                  <div :id="`state-${states.indexOf(item)}`" class="v-list__tile__title">{{ item.name }}</div>
                </div>
              </template>
            </VSelect>

            <SmartInput
              label="Endereço *"
              id="address"
              v-model="address"
              name="address"
              placeholder="Rua das Graças"
              v-validate="'required'"
              :error="errors.first('address')"
            />
            <SmartInput
              label="Número *"
              id="number"
              v-model="number"
              name="number"
              placeholder="503"
              v-validate="'required'"
              :error="errors.first('number')"
            />

            <SmartInput
              label="Longitude *"
              id="longitude"
              name="longitude"
              v-model="longitude"
              placeholder="0000000000000"
              v-validate="'required'"
              disabled
            />
          </div>
        </SmartRow>
        <div class="flex justify-between align-center ml-1 mr-2 mt-3">
          <span class="font-opacity-md">Selecione o local no mapa</span>
          <SmartButton
            secondary
            :disabled="addressFormValid"
            @click="addMarker"
          >Aplicar Endereço</SmartButton>
        </div>
      </div>
    </SmartCard>

    <SmartCard>
      <gmap-map
        :center="center"
        :zoom="15"
        ref="map"
        style="width:100%;  height: 400px;"
      >
        <gmap-marker
          v-if="marker.position.lat && marker.position.lng"
          :position="marker.position"
          draggable
          @dragend="({ latLng }) => {
            center = {
              lat: latLng.lat(),
              lng: latLng.lng()
            };
            marker.position = center
          }"
        />
        <gmap-circle
          v-if="marker.position.lat && marker.position.lng"
          :center="marker.position"
          :radius="radius"
          :visible="true"
          :options="options"
        />
      </gmap-map>
      <div class="pt-3 pl-4 pb-1">
        <span class="font-opacity-md">Raio de Alcance do Ponto de Venda - {{ radiusInKM() }}</span>
        <div class="flex align-center justify-space-around">
          <v-slider
            class="col-8"
            :max="slider.max"
            :min="slider.min"
            :step="slider.step"
            v-model="radius"
          />
          <span class="font-opacity-md">3KM de Alcance</span>
        </div>
      </div>
      <div class="flex justify-end p-3">
        <SmartButton
          class="mr-2"
          secondary
          @click="goToPreviousPage"
        >Cancelar Criação</SmartButton>
        <SmartButton
          :disabled="!isFormValid"
          @click="submit"
        >Criar PDV</SmartButton>
      </div>
    </SmartCard>
    <SmartModal
      v-if="modal"
      v-bind="modal"
      @close="modal = null"
    >
      {{ modal.text }}
    </SmartModal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { gmapApi } from '@/vueGoogleMaps/vue2-google-maps/src/main';
import { formatUSDate } from 'utils/date';
import states from 'constants/states';

export default {
  data() {
    return {
      radius: 1000,
      states,
      center: { lat: 10, lng: 10 },
      marker: {
        position: {}
      },
      places: [],
      currentPlace: null,
      slider: {
        max: '3000',
        step: '100',
        min: '0'
      },
      options: {
        fillColor: 'red',
        fillOpacity: 0.2,
        strokeColor: 'red',
        strokeOpacity: 0.4,
        strokeWeight: 0.8
      },
      companyName: '',
      cpfCnpj: '',
      placeName: '',
      custCode: '',
      phone: '',
      zipCode: '',
      state: '',
      city: '',
      neighborhood: '',
      address: '',
      number: '',
      complement: '',
      segmentSelected: '',
      selectedViews: [],
      selectedDistributors: '',
      branch: ['SIM', 'NÃO'],
      selectBranch: '',
      submitBranch: '',
      submitDDDS: '',
      latitude: '',
      longitude: '',
      modal: null,
      selectedChannels: '',
      simcard_curve: '',
      top_up_curve: '',
      status: false,
      salesmanName: '',
      salesmanCpf: ''
    };
  },
  name: 'NewPlace',
  computed: {
    google: gmapApi,
    ...mapGetters({
      cities: 'address/cities',
      getCityById: 'address/getCityById',
      channels: 'channel/channels',
      getPlaceByCustCode: 'place/getPlaceByCustCode',
      getPlaceSegments: 'place/placeSegments',
      views: 'view/views',
      distributors: 'distributors/distributors',
      listDDD: 'distributors/ddds'
    }),
    addressFormValid() {
      return (
        !this.number
        || !this.address
        || !this.neighborhood
        || !this.city
        || !this.state
        || !this.zipCode
        || !this.complement
      );
    },
    isFormValid() {
      return Object.keys(this.fields).every(field => this.fields[field].valid);
    },
    changeValidateCpfCnpj() {
      return this.cpfCnpj
        .replace(/[./-]/g, '')
        .length === 14 ? 'required|cnpj' : 'required|cpf';
    }
  },
  methods: {
    ...mapActions({
      createPdv: 'place/createPdv',
      fetchCities: 'address/fetchCities',
      fetchChannelSigtim: 'channel/fetchChannelSigtim',
      fetchLocation: 'address/fetchLocation',
      fetchAddressByCep: 'address/fetchAddressByCep',
      fetchPlaceByCustCode: 'place/fetchPlaceByCustCode',
      fetchPlaceSegments: 'place/fetchPlaceSegments',
      fetchViews: 'view/fetchViewsSigtim',
      fetchAllDistributors: 'distributors/fetchAllDistributors',
      fetchDDDS: 'distributors/fetchDDDS'
    }),
    alterValueBranch(value) {
      if (value === 'SIM') {
        this.submitBranch = 1;
      } else {
        this.submitBranch = 0;
      }
    },
    alterStatusSwitchOfNullToFalse(value) {
      if (value == null) {
        this.status = false;
      }
    },
    setPlace(place) {
      this.currentPlace = place;
    },
    async addMarker() {
      const nameCity = this.getCityById(this.city).name;
      const address = `${this.number},${this.address},${this.neighborhood},${nameCity},${this.state},${this.zipCode},Br`;

      await this.fetchLocation(address.replace(/ /g, '+')).then((location) => {
        this.marker.position = location;
        this.center = location;
        this.latitude = location.lat;
        this.longitude = location.lng;
      });
    },
    reloadCities(value) {
      this.fetchCities(value);
    },
    reloadAddress() {
      this.fetchAddressByCep(this.zipCode.match(/\d/g).join('')).then((data) => {
        this.neighborhood = data.bairro;
        this.address = data.logradouro;
        this.state = data.estado;
        this.fetchCities(data.estado).then(() => {
          const cityId = parseInt(data.cidade_info.codigo_ibge, 10);
          this.city = cityId;
        });
      })
        .catch(({ data }) => {
          this.isLoading = false;
          this.modal = {
            type: 'warning',
            title: 'Ops!',
            icon: 'alert',
            buttonText: 'Tentar novamente',
            text: data.error ? data.error.message : 'Erro desconhecido'
          };
        });
    },
    submit() {
      const addressArray = this.address.split(' ');
      this.createPdv({
        custCode: this.custCode,
        body: {
          db_id: this.selectedDistributors,
          pdv: [
            {
              name: this.placeName,
              cnpj: this.cpfCnpj,
              company_name: this.companyName,
              address: addressArray.slice(1).join(' '),
              type_of_street: addressArray[0],
              neighborhood: this.neighborhood,
              zip_code: this.zipCode.match(/\d/g).join(''),
              state: this.state,
              city: this.getCityById(this.city).name,
              number: this.number,
              complement: this.complement,
              latitude: this.marker.position.lat,
              longitude: this.marker.position.lng,
              telephone: this.phone,
              radius: this.radius,
              channel_id: this.selectedChannels,
              views: [this.selectedViews],
              integration_date: formatUSDate(new Date()),
              ddd_id: this.submitDDDS,
              place_segments_id: this.segmentSelected,
              branch: this.submitBranch,
              simcard_curve: this.simcard_curve,
              top_up_curve: this.top_up_curve,
              status: this.status,
              source: 'SIGTIM',
              salesman_name: this.salesmanName,
              salesman_cpf: this.salesmanCpf
            }
          ]
        }
      }).then(({ data }) => {
        if (data && data.data && data.data.conflicts && data.data.conflicts.length) {
          const message = 'PDV criado com sucesso, porém com conflito de endereço.';
          this.modalSuccess(message);
        } else {
          const message = 'Ponto de Venda criado com sucesso';
          this.modalSuccess(message);
        }
      })
        .catch(({ data }) => {
          // TODO código abaixo está do jeito que está pois os backenders não conseguem devolver de modo que eu possa
          // prever como terá de ser tratado. Assim que houver solução, deve ser refatorado
          let message = '';
          if (data.errors) {
            Object.keys(data.errors[0]).forEach((item) => {
              message = data.errors[0][item];
            });
            this.modal = {
              type: 'warning',
              title: 'Ops!',
              icon: 'alert',
              buttonText: 'Tentar novamente',
              text: message.message[0] || 'Erro desconhecido'
            };
          }
          this.modalError(data);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    radiusInKM() {
      return `${this.radius / 1000}km`;
    },
    goToPreviousPage() {
      const lastPageIndex = this.$route.path.lastIndexOf('/');
      const lastURL = this.$route.path.substring(0, lastPageIndex);

      this.$router.push(lastURL);
    },
    modalSuccess(msg) {
      this.modal = {
        type: 'success',
        title: 'Ponto de Venda Criado',
        icon: 'accepted',
        buttonText: 'Ok',
        text:
              msg || 'O Ponto de Venda foi criado com sucesso e já está disponível para a visualização',
        routerRedirect: 'Place'
      };
    },
    modalError(data) {
      this.modal = {
        type: 'warning',
        title: 'Ops!',
        icon: 'alert',
        buttonText: 'Tentar novamente',
        text: data || 'Erro desconhecido!'
      };

      if (data) {
        const error = data.errors ? data.errors[0] : data.data.errors[0];
        const cnpj = Object.keys(error)[0];

        this.modal = {
          type: 'warning',
          title: 'Ops!',
          icon: 'alert',
          buttonText: 'Tentar novamente',
          text: data.errors ? 'É necessário um tipo de logradouro.' : error[cnpj].message[0] || 'Erro desconhecido'
        };
      }
    }
  },
  async mounted() {
    await this.fetchViews();
    await this.fetchPlaceSegments();
    await this.fetchAllDistributors();
    await this.fetchDDDS();
    await this.fetchChannelSigtim();
  }
};
</script>

<style scoped>
</style>

<style lang="scss">
.sub-form {
  .smart-input__wrapper {
    margin-bottom: $spacing-margin-xsmall;
  }
}
.status-box {
  width: 140px;
}
.switch-right {
  right: 0;
  height: 25px;
}
</style>
